export default "__VITE_ASSET__D$CWdqxa__"